const actions = {
  SET_STATE: 'subscription/SET_STATE',
  CHANGE_PLAN: 'subscription/CHANGE_PLAN',
  GET_PLANS: 'subscription/GET_PLANS',
  GET_SUBSCRIPTION: 'subscription/GET_SUBSCRIPTION',
  GET_INVOICES: 'subscription/invoice'
}

export default actions
